export default __webpack_public_path__ + "static/media/StepsActive04.388eed0f.svg";